export default {
  // 星期
  weekDay: ['周一','周二','周三','周四','周五','周六','周日'],
  // 用户类型
  userTypeList: [
    { label: '不限制', value: -1 },
    { label: '油站新客户', value: 0 },
    { label: '油站老客户', value: 1 }
  ],
  // 投放渠道
  pushChannelList: ['仅团油平台', '仅部分三方平台', '团油和部分三方平台']
}
